import FeatherIcon from "feather-icons-react";
import { Dropdown, DropdownItem, DropdownMenu, Form, FormField, FormGroup } from "semantic-ui-react";
import SVG_BANKS from "../../../../../../assets/svg/svg_banks";
import { formatRut, rutWithNumbers } from "src/utils/formatter";
import CustomModal from "src/components/configuracion/components/customModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BankSelection from "../../bankSelection";
import { CreateBankAccount, DeleteBankAccount, EditBankAccount, MakeMainBankAccount } from "src/graphql/agenda";
import { importAlertState } from "src/redux/actions/alert";
import { useDispatch } from "react-redux";
import { importAgendaUpdateNeeded } from "src/redux/actions/agenda";
import { banksFormat } from "src/utils/bankList";
import "./BankDetail.scss";

export const BankDetail = ({ agenda, bankAccountTypes, agendaId, reexecuteQueryAgenda }) => {
    const { t } = useTranslation("agenda");
    const dispatch = useDispatch()

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [delelteModalIsOpen, setDeleteModalIsOpen] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);

    const [selectedBank, setSelectedBank] = useState('');
    const [bankAccountType, setBankAccountType] = useState('');
    const [bankRut, setBankRut] = useState('');
    const [bankAccountNumber, setAccountNumber] = useState('');
    const [bankAccountEmail, setBankAccountEmail] = useState('');
    const [bankAccountId, setBankAccountId] = useState('');
    const [emailError, setEmailError] = useState("");

    const [isEditModal, setIsEditModal] = useState(false);


    const { executeMutation: makeMainBankAccountQuery, fetching: makeMainFetching } = MakeMainBankAccount()
    const { executeMutation: executeMutationDeleteBankAccount, fetching: deleteFetching } = DeleteBankAccount();
    const { executeMutation: createBankAccountMutation, data: createBankAccountData, fetching: createBankAccountFetching } = CreateBankAccount();
    const { executeMutation: editBankAccountMutation, data: editBankAccountData, fetching: editBankAccountFetching } = EditBankAccount();

    // **************************** logica *********************************
    const onCloseModal = () => {
        setSelectedBank('');
        setBankAccountType('');
        setBankRut('');
        setAccountNumber('');
        setBankAccountId('');
        setBankAccountEmail('');
        setFormIsValid(false);
        setModalIsOpen(false);
        setIsEditModal(false);
        setDeleteModalIsOpen(false);
    }

    const validateForm = () => {
        const isFormValid = selectedBank && bankAccountType && bankRut && bankAccountNumber;
        setFormIsValid(isFormValid);
    };

    const createBankAccount = async () => {
        if (!agendaId) {
            dispatch(
                importAlertState({
                    content: `Error: No se pudo identificar el contacto. Por favor, intente nuevamente.`,
                    state: 'error',
                    duration: 4,
                })
            );
            setModalIsOpen(false);
            onCloseModal();
            return;
        }

        const bankAccountData = {
            bankId: selectedBank,
            bankAccountType,
            bankRut,
            bankAccount: bankAccountNumber,
            email: bankAccountEmail
        };

        const { error: createBankAccountError } = await createBankAccountMutation({ agendaId, bankAccount: bankAccountData });

        if (!createBankAccountError) {
            reexecuteQueryAgenda({ requestPolicy: "network-only" });
            setModalIsOpen(false);
            onCloseModal();
            dispatch(
                importAlertState({
                    content: `Cuenta bancaria creada exitosamente`,
                    state: 'success',
                    duration: 4,
                })
            );
            dispatch(importAgendaUpdateNeeded({ value: true }));
        } else {
            dispatch(
                importAlertState({
                    content: `Error al crear la cuenta bancaria`,
                    state: 'error',
                    duration: 4,
                })
            )
        }

    };

    const editBankAccount = async () => {
        if (!agendaId) {
            dispatch(
                importAlertState({
                    content: `Error: No se pudo identificar el contacto. Por favor, intente nuevamente.`,
                    state: 'error',
                    duration: 4,
                })
            );
            setModalIsOpen(false);
            onCloseModal();
            return;
        }

        const bankAccountData = {
            bankId: selectedBank,
            bankAccountType,
            bankRut,
            bankAccount: bankAccountNumber,
            email:bankAccountEmail,
            id: bankAccountId
        };

        const { error: editBankAcccountError } = await editBankAccountMutation({ agendaId, bankAccount: bankAccountData });

        if (!editBankAcccountError) {
            reexecuteQueryAgenda({ requestPolicy: "network-only" });
            setModalIsOpen(false);
            onCloseModal();
            dispatch(
                importAlertState({
                    content: `Cuenta bancaria creada exitosamente`,
                    state: 'success',
                    duration: 4,
                })
            );
            dispatch(importAgendaUpdateNeeded({ value: true }));
        } else {
            dispatch(
                importAlertState({
                    content: `Error al crear la cuenta bancaria`,
                    state: 'error',
                    duration: 4,
                })
            )
        }

    };

    const makeMainBankAccount = async (agendaId, bankAccountId) => {
        importAlertState({
            content: "Marcando cuenta bancaria como principal.",
            state: "loading",
            duration: 2,
        });

        const { error: makeMainBankAccountError } = await makeMainBankAccountQuery({ agendaId, bankAccountId });
        if (!makeMainBankAccountError) {
            dispatch(
                importAlertState({
                    content: `Cuenta bancaria marcada como principal exitosamente`,
                    state: 'success',
                    duration: 4,
                })
            );
            reexecuteQueryAgenda({ requestPolicy: "network-only" });
        } else {
            dispatch(
                importAlertState({
                    content: `Error al marcar cuenta bancaria como principal`,
                    state: 'error',
                    duration: 4,
                })
            );
        }
    }

    const deleteBankAccount = async (agendaId, bankAccountId) => {
        importAlertState({
            content: "Eliminando cuenta bancaria.",
            state: "loading",
            duration: 2,
        });

        const { error: deleteBankAccountError } = await executeMutationDeleteBankAccount({ agendaId, bankAccountId });
        if (!deleteBankAccountError) {
            dispatch(
                importAlertState({
                    content: `Cuenta bancaria eliminada exitosamente`,
                    state: 'success',
                    duration: 4,
                })
            );
            reexecuteQueryAgenda({ requestPolicy: "network-only" });
            onCloseModal();
        } else {
            dispatch(
                importAlertState({
                    content: `Error al eliminar cuenta bancaria`,
                    state: 'error',
                    duration: 4,
                })
            );
        }
    }

    useEffect(() => {
        validateForm();
    }, [selectedBank, bankAccountType, bankRut, bankAccountNumber, bankAccountEmail]);

    const setData = (bankAccount, isDelete) => {
        setSelectedBank(bankAccount.bankId);
        setBankAccountType(bankAccount.bankAccountType);
        setBankRut(rutWithNumbers(bankAccount.bankRut || ''));
        setAccountNumber(bankAccount.bankAccount);
        setBankAccountEmail(bankAccount.email);
        setBankAccountId(bankAccount.id);
        if (isDelete) {
            setDeleteModalIsOpen(true);
        } else {
            setIsEditModal(true);
        }
    }

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const email = e.target.value;
        setBankAccountEmail(email);
        setEmailError(validateEmail(email) ? "" : "Email inválido");
    };

    return (
        <div className="parametrizacion-tab-content">
            <div className="parametrizacion-section" style={{ minHeight: 'fit-content' }}>
                <span className="parametrizacion-section-title">{t("bankDetail.title")}</span>

                {
                    agenda?.bankAccounts.length > 0 &&
                    <section className="bank-detail-list-header tw-w-full tw-h-[39px] tw-rounded-xl tw-flex tw-items-center tw-text-gray-700">
                        <div className="tw-w-[55.6%] tw-px-4 tw-py-3">
                            <span className="tw-text-sm tw-font-medium">
                                Cuenta
                            </span>
                        </div>
                        <div className="tw-flex-grow tw-px-4 tw-py-3">
                            <span className="tw-text-sm tw-font-medium">
                                Rut destinatario
                            </span>
                        </div>
                    </section>
                }

                {
                    agenda?.bankAccounts.map((bankAccount, index) => {
                        return (
                            <section key={bankAccount?.id || index} className="bank-detail-list-row tw-w-full tw-h-[50px] tw-rounded-lg tw-flex tw-mt-2">
                                <div className="tw-w-[55.6%] tw-px-4 tw-py-2 tw-flex tw-gap-3">
                                    <div className="tw-w-[35px] tw-h-[35px] tw-rounded">
                                        <img src={SVG_BANKS(bankAccount?.bankId)} alt="" className="" style={{ width: '35px', height: '35px' }} />
                                    </div>

                                    <div className="tw-flex tw-flex-col tw-text-gray-700">
                                        <span className="tw-text-sm tw-font-medium">
                                            {bankAccount?.bankAccount}
                                        </span>
                                        <span className="tw-text-sm tw-font-light">
                                            Cuenta {bankAccount?.bankAccountType}
                                        </span>
                                    </div>
                                </div>

                                <div className="tw-w-[37%] tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center">
                                    <span className="tw-text-sm tw-font-medium">
                                        {formatRut(bankAccount.bankRut)}
                                    </span>

                                    {
                                        bankAccount.isMain &&
                                        <div className="tw-w-[74px] tw-h-[28px] tw-bg-[#EEF8FF] tw-rounded-md tw-flex tw-items-center tw-justify-center">
                                            <span className="tw-text-[#1D7EE3] tw-text-sm tw-font-medium">
                                                Principal
                                            </span>
                                        </div>
                                    }
                                </div>

                                <div className="tw-flex-grow tw-flex tw-items-center tw-justify-end tw-px-3">
                                    <Dropdown
                                        icon={
                                            <FeatherIcon
                                                icon="more-vertical"
                                            />
                                        }
                                        direction="left"
                                        disabled={makeMainFetching || deleteFetching}
                                    >
                                        <DropdownMenu className="tw-w-[168px]">
                                            {
                                                bankAccount.isMain &&
                                                <DropdownItem disabled>
                                                    <span className="tw-text-base tw-font-medium tw-text-gray-700">
                                                        Ya es el principal
                                                    </span>
                                                </DropdownItem>
                                            }
                                            {
                                                !bankAccount.isMain &&
                                                <DropdownItem onClick={() => makeMainBankAccount(agenda?.id, bankAccount?.id)}>
                                                    <span className="tw-text-base tw-font-medium tw-text-gray-700">
                                                        Cuenta principal
                                                    </span>
                                                </DropdownItem>
                                            }
                                            <DropdownItem onClick={() => setData(bankAccount, false)}>
                                                <span className="tw-text-base tw-font-medium tw-text-gray-700">
                                                    Editar
                                                </span>
                                            </DropdownItem>
                                            <DropdownItem onClick={() => setData(bankAccount, true)}>
                                                <span className="tw-text-base tw-font-medium tw-text-gray-700">
                                                    Eliminar
                                                </span>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </section>
                        )
                    })
                }
            </div>
            <div className="parametrization-buttons" style={{ marginBottom: 0 }}>
                <button
                    type="button"
                    className="parametrization-btn parametrization-btn--secondary"
                    onClick={(event) => {
                        event.preventDefault();
                        if (!agendaId) {
                            dispatch(
                                importAlertState({
                                    content: `Error: No se pudo identificar el contacto. Por favor, intente nuevamente.`,
                                    state: 'error',
                                    duration: 4,
                                })
                            );
                            return;
                        }
                        setModalIsOpen(true);
                    }}
                    disabled={!agendaId}
                    title={!agendaId ? "Esperando información del contacto" : ""}
                >
                    <FeatherIcon icon="plus" size={16} style={{ marginRight: 8 }} />
                    {t("bankDetail.newRecord")}
                </button>
            </div>

            <CustomModal
                open={modalIsOpen || isEditModal}
                onClose={onCloseModal}
                title={isEditModal ? 'Editar cuenta bancaria' : 'Crear cuenta bancaria'}
                confirmLabel={isEditModal ? 'Editar' : 'Crear'}
                size="small"
                confirmDisabled={!formIsValid || !agendaId || createBankAccountFetching || editBankAccountFetching}
                onConfirm={isEditModal ? editBankAccount : createBankAccount}
                isLoading={createBankAccountFetching || editBankAccountFetching}
                content={
                    <div className="parametrizacion-section">
                        <Form className="tw-w-full tw-flex tw-flex-col tw-gap-4">
                            <FormField className="!tw-m-0 field">
                                <label className="label">BANCO</label>
                                <BankSelection
                                    onChange={(_, { value }) => setSelectedBank(value)}
                                    value={selectedBank}
                                />
                            </FormField>

                            <FormGroup className="tw-w-full !tw-m-0 tw-flex tw-gap-[16px] field-row">
                                <FormField className="tw-w-[50%] !tw-p-0 field">
                                    <label className="label">TIPO DE CUENTA</label>
                                    <Dropdown
                                        placeholder='Seleccione tipo de cuenta'
                                        fluid
                                        search
                                        selection
                                        options={bankAccountTypes}
                                        onChange={(_, { value }) => setBankAccountType(value)}
                                        value={bankAccountType}
                                    />
                                </FormField>
                                <FormField className="tw-w-[50%] !tw-p-0 field">
                                    <label className="label">RUT DESTINATARIO</label>
                                    <input
                                        placeholder="Ingrese RUT destinatario"
                                        value={formatRut(bankRut)}
                                        maxLength={12}
                                        onChange={(e) => setBankRut(rutWithNumbers(e.target.value))}
                                    />
                                </FormField>
                            </FormGroup>
                            <FormField className="!tw-m-0 field">
                                <label className="label">CUENTA BANCARIA</label>
                                <input
                                    placeholder="Ingrese cuenta bancaria"
                                    onChange={(e) => setAccountNumber(e.target.value)}
                                    value={bankAccountNumber}
                                />
                            </FormField>
                            <FormField className="field">
                                <label className="label">EMAIL</label>
                                <input
                                    type="email"
                                    placeholder="Ingrese email"
                                    onChange={handleEmailChange}
                                    value={bankAccountEmail}
                                />
                                {emailError && <p className="tw-text-red-500 tw-text-xs">{emailError}</p>}
                            </FormField>
                        </Form>
                    </div>
                }
            />

            <CustomModal
                open={delelteModalIsOpen}
                onClose={onCloseModal}
                title={'Eliminar cuenta bancaria'}
                confirmLabel={'Eliminar'}
                size="small"
                onConfirm={() => deleteBankAccount(agenda?.id, bankAccountId)}
                confirmDisabled={deleteFetching}
                isLoading={deleteFetching}
                content={
                    <div>
                        <span className="tw-text-base tw-font-light tw-text-gray-700">
                            ¿Está seguro que desea eliminar la cuenta bancaria con numero <strong>{bankAccountNumber}</strong> del <strong>{banksFormat[selectedBank]}</strong>?
                        </span>
                    </div>
                }
            />
        </div>
    );
}